



















































import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
import { portfolioStore } from "@/portfolio/store";
import { Performance, Portfolio } from "./types";

const faker = require("faker");

@Component({
  components: {}
})
export default class PerformanceTab extends Vue {
  options = {
    chart: {
      id: "vuechart-example"
    },
    markers: {
      size: 5
    },
    xaxis: {
      categories: [...Array(12).keys()].map((_, i) => i + 1)
    }
  };

  series = [
    {
      name: "Property 1",
      data: [...Array(12).keys()].map((_, i) =>
        faker.random.number({ min: i * 100, max: i + 1 * 100 })
      )
    },
    {
      name: "property 2",
      data: [...Array(12).keys()].map(
        (_, i) => faker.random.number({ min: i * 100, max: i + 1 * 100 }) - 40
      )
    }
  ];

  doptions = {};
  dseries = [44, 55, 41, 17, 15];
  defaultPerformance: Performance = {
    appreciation: 0,
    buyingPower: 0,
    dividendsEarned: 0,
    portfolioValue: 0
  };
  async mounted() {
    if (portfolioStore.state.items.length === 0) {
      await portfolioStore.loadPortfolio();
    }
    this.defaultPerformance = portfolioStore.state.items[0].performance;
  }
}
